import exifr from 'exifr';

/**
 * Extract GPS coordinates from image EXIF metadata
 * @param {File} file - The image file to extract GPS from
 * @returns {Promise<{latitude: number, longitude: number} | null>} - GPS coordinates or null if not available
 */
export const extractGPSFromImage = async (file) => {
  try {
    // Parse EXIF data from the image file
    const exifData = await exifr.parse(file, {
      gps: true, // Extract GPS data
      tiff: false, // Skip TIFF data
      exif: false, // Skip general EXIF data
      iptc: false, // Skip IPTC data
      ifd0: false, // Skip IFD0 data
      ifd1: false, // Skip IFD1 data
    });

    // Check if GPS data exists
    if (!exifData || !exifData.latitude || !exifData.longitude) {
      console.log('No GPS data found in image EXIF metadata');
      return null;
    }

    const { latitude, longitude } = exifData;

    // Validate coordinate ranges
    // Latitude: -90 to 90
    // Longitude: -180 to 180
    if (
      typeof latitude !== 'number' ||
      typeof longitude !== 'number' ||
      latitude < -90 ||
      latitude > 90 ||
      longitude < -180 ||
      longitude > 180
    ) {
      console.warn('Invalid GPS coordinates in EXIF data:', { latitude, longitude });
      return null;
    }

    console.log('GPS coordinates extracted from image:', { latitude, longitude });
    return {
      latitude,
      longitude,
    };
  } catch (error) {
    console.error('Error extracting GPS from image:', error);
    return null;
  }
};
